<template>
  <div class="sidebar" >
    <el-menu
      :default-active="active"
      class="sidebar-el-menu"
      @select="handleSelect"
      unique-opened
    >
      <el-input placeholder="请输入内容" v-model="shop_name" class="input-with-select" @change="searchMenu" >
        <el-button slot="suffix" icon="el-icon-search" @click="searchMenu"></el-button>
        <el-button slot="append" type="danger" @click="refreshMenu" style="background-color: red!important;color:white;">重置</el-button>
      </el-input>
        <el-menu-item index="all">
            <i class="el-icon-tickets"></i>
            <span slot="title">全部</span>
        </el-menu-item>
      <template v-for="item of items">
        <el-menu-item :index="item.email" :key="item.id">
          <i class="el-icon-tickets"></i>
          <span slot="title">{{ item.email }}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
  name: "SideBar",
  data() {
    return {
      items: [],
      active:"all",
      shop_name:'',
    };
  },

  computed: {
    ...mapState(['user_info']),
  },
  methods: {
    refreshMenu(){
      this.active = 'all'
      this.shop_name = '';
      this.getMenu(false)
    },
    searchMenu(){
      this.getMenu(true);
    },
    handleSelect(key) {
      this.active = key;
      this.$emit("onSelect", key)

    },
    getMenu(bool) {
      let data = {};
      if(bool&&this.shop_name!='') data= {'keyword':this.shop_name};
      this.http.fetchGet(this.api.dispute_menu,data).then((res) => {
        var data = res.data
        if (data.code === 200) {
          this.items = data.data
          // this.active=this.items[0].email
          if(!bool) this.$emit("onSelect", this.active)
        } else {
          this.$message.error(data.msg);
        }
      }).catch(err => {
        console.log(err)
      })
    }
  },
  mounted() {
    this.getMenu()
  }
}

</script>
<style>
.el-input--suffix .el-input__inner{
  width: 98%;
}
</style>
<style lang="stylus" scoped>
@import '~@/assets/css/varibles.styl';

.sidebar {
  display: block;
  position: absolute;
  left: 0;
  top: .625rem;
  bottom: 0;
  overflow-y: scroll;

  ul {
    height: 100%;
  }
}

.sidebar::-webkit-scrollbar {
  width: 0;
}

.sidebar-el-menu:not(.el-menu--collapse) {
  width: $SbWidth;
}
</style>
